import { get, post } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useFetchReferCodeUserNew = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        const { tabName, pageNumber, pageSize,searchFilter } = data;

        // Build the URL with optional parameters
        let url = `referandearn/referral-users/list?tabName=${tabName}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

        // Add userID and searchFilter only if they are provide
        if (searchFilter) {
            url += `&searchFilter=${searchFilter}`;
        }

        // Perform the GET request
        return await get(url);
    }, options);
};

export const useFetchReferCodeUser = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        // const { tabName, pageNumber, pageSize,searchFilter } = data;

        // // Build the URL with optional parameters
        // let url = `referandearn/referral-users/list?tabName=${tabName}&pageNumber=${pageNumber}&pageSize=${pageSize}`;

        // // Add userID and searchFilter only if they are provide
        // if (searchFilter) {
        //     url += `&searchFilter=${searchFilter}`;
        // }

        // Perform the GET request
        return await get("referandearn/referral-users/list?tabName="+ data.tabName + "&searchFilter=" + data.searchFilter + "&pageNumber=" + data.pageNumber + "&pageSize=" + data.pageSize) ;
    }, options);
};

export const useReferCodeUpdate = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post("referandearn/referral-code/update", data);
    }, options);
};